"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emailHandler = void 0;
var HandlerMapping_1 = require("../handler/HandlerMapping");
var stringHandler_1 = require("./stringHandler");
function emailHandler(data, options) {
    if (options === void 0) { options = { leaveLetters: 0, leaveDomain: false }; }
    if (typeof data !== 'string' || !data.includes('@')) {
        return HandlerMapping_1.HandlerMapping.handlersMapping.default(data);
    }
    var _a = data.split('@'), name = _a[0], domain = _a[1];
    name = (0, stringHandler_1.stringHandler)(name, { leaveLetters: options.leaveLetters });
    if (!options.leaveDomain) {
        // eslint-disable-next-line no-useless-escape
        domain = domain.replace(/[^\.\s]/g, '*');
    }
    return "".concat(name, "@").concat(domain);
}
exports.emailHandler = emailHandler;
//# sourceMappingURL=emailHandler.js.map